import useRequest from '@/websdk/utils/request';
export default (function () {
    const { exec, isRequestSuccessed } = useRequest({
    name: 'POST_FIRST_INSPECTION',
    url: `/api/inspection/first/inferiors/`,
    method: 'POST',
  });
 

  return [exec, isRequestSuccessed];
});
